<m-panel
  class="fiche-repondant-available-cas-special-row"
  :class="panelClasses"
  :shadow="true"
  @click="onPanelClick"
>
  <template #header>
    <template v-if="casSpecial.examen">
      <h6 v-html="$i18next.t('modules.fiche-repondant.form.FicheRepondantAvailableCasSpecialRow.panel.title', casSpecial.examen)" />
    </template>
  </template>
  <template #header-right-content>
    <template v-if="isSelected">
      <m-icon name="m-svg__right-answer" />
    </template>
  </template>
  <div class="fiche-repondant-available-cas-special-row__content">
    <template v-if="casSpecial.horodateCasSpecial">
      <div class="fiche-repondant-available-cas-special-row__content--timestamp">
        <m-icon name="m-svg__calendar" />
        &nbsp;&nbsp;{{ casSpecial.horodateCasSpecial.periode }}
      </div>
    </template>
    <template v-if="!mixin_string_isEmpty(casSpecial.villeEtudiant) && !mixin_string_isEmpty(casSpecial.paysEtudiant)">
      <div class="fiche-repondant-available-cas-special-row__content--location">
        <location-svg />
        &nbsp;{{ $i18next.t('modules.fiche-repondant.form.FicheRepondantAvailableCasSpecialRow.panel.content.location', casSpecial) }}
      </div>
    </template>
  </div>
</m-panel>